/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Unregister_BtnInputs */



/**
* | output |
* | --- |
* | "Unregister" |
*
* @param {Tournament_Unregister_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_unregister_btn = /** @type {((inputs?: Tournament_Unregister_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Unregister_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Se désinscrire")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cancelar inscripción")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Cancelar Inscrição")
	if (locale === "it") return /** @type {LocalizedString} */ ("Annulla iscrizione")
	return /** @type {LocalizedString} */ ("Unregister")
});